"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _reactDom = _interopRequireDefault(require("react-dom"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Portal component renders its children in a separate portal container appended to the document body.
 *
 * While `@gorhom/portal` works well for a lot of use-cases, there are some issues with it, particularly around
 * reading context values (see issues below). For web-only components, it is safe to replace `Portal` from `@gorhom/portal`
 * to `Portal` to solve such issues
 *
 * https://github.com/gorhom/react-native-portal/issues/34
 * https://github.com/gorhom/react-native-portal/issues/2
 * https://github.com/gorhom/react-native-portal/issues/3
 * https://github.com/gorhom/react-native-portal/issues/31
 *
 * @component
 * @param {object} props - The component props.
 * @param {React.ReactNode} props.children - The content to render within the portal.
 * @returns {React.ReactPortal} The React portal component.
 */

const Portal = _ref => {
  let {
    children
  } = _ref;
  const [portalContainer, setPortalContainer] = (0, _react.useState)(null);
  const isWebClient = typeof document !== 'undefined' && typeof window !== 'undefined';
  (0, _react.useEffect)(() => {
    if (!isWebClient) {
      return;
    }
    const container = document.createElement('div');
    document.body.appendChild(container);
    setPortalContainer(container);

    // eslint-disable-next-line consistent-return
    return () => {
      if (container && container.parentNode) {
        container.parentNode.removeChild(container);
      }
    };
  }, [isWebClient]);
  if (!portalContainer || !isWebClient) return null;
  return /*#__PURE__*/_reactDom.default.createPortal(children, portalContainer);
};
Portal.propTypes = {
  children: _propTypes.default.node.isRequired
};
var _default = exports.default = Portal;